import { useTranslation } from 'react-i18next';

import classes from '../FRBWidget.module.scss';

export function CountdownType({ countdownMinutes }: { countdownMinutes: number }) {
  const { t } = useTranslation();
  return (
    <div className={classes.countdownType}>
      <div className={classes.inner}>
        <div className={classes.title}>{t('frb.freeSpins')}</div>
        <div className={classes.details}>
          <span>{t('frb.for')}</span>
          <span>{countdownMinutes}</span>
          <span>{t('frb.secs')}</span>
        </div>
      </div>
    </div>
  );
}
